/**
 * Sets the header height dynamically based on the content size.
 * @function setHeaderHeightVar
 */
const setHeaderHeightVar = () => {

	const element = document.querySelector( '.page-header' );

	if ( element && 'ResizeObserver' in window ) {

		const resizeObserver = new ResizeObserver( entries => {

			for ( const entry of entries ) {


				document.documentElement.style.setProperty( '--header-height', `${entry.contentRect.height}px` );

			}

		} );

		resizeObserver.observe( element );

	}

}
export { setHeaderHeightVar };
